import React from "react";
import PropTypes from "prop-types";
import "./TextElement.css";
import ItemTypes from "../../../../../../constants/ItemTypes";
import { DragSource } from "react-dnd";
import { getEmptyImage } from "react-dnd-html5-backend";
import TextElement from "../TextElement";

const textSource = {
  beginDrag(props) {
    // Return the data describing the dragged item
    const isDragging = true,
      isSelected = props.textElement.is_selected;

    props.handleIsDragging(isDragging, isSelected);

    const item = calculatePosition(props);
    item.element = props.textElement;
    item.type = ItemTypes.TEXT;
    item.index = props.index;
    item.layerId = props.layerId;
    item.isSelected = props.textElement.is_selected;
    item.width = props.textElement.width * 72 * props.design.preview_scale;
    item.height = props.textElement.height * 72 * props.design.preview_scale;
    item.guidesVisible = props.guidesVisible;
    return item;
  },

  endDrag(props, monitor, component) {
    const isDragging = false,
      isSelected = false;

    props.handleIsDragging(isDragging, isSelected);

    if (!monitor.didDrop()) {
      return;
    }
  }
};

function collect(connect, monitor) {
  return {
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging()
  };
}

function calculatePosition(props) {
  let position = {};
  const scale = 72 * props.design.preview_scale;

  // Ensure we have valid numbers for positions
  const topPosition = props.textElement.top_position || 0;
  const leftPosition = props.textElement.left_position || 0;

  position.top = topPosition * scale;
  position.left = leftPosition * scale;

  // Ensure we don't return NaN values
  if (isNaN(position.top)) position.top = 0;
  if (isNaN(position.left)) position.left = 0;

  return position;
}

function getStyles(props) {
  const { isDragging } = props;

  const hideElement =
    isDragging || (props.textElement.is_selected && props.isDraggingSelected);

  return {
    opacity: hideElement ? 0 : 1,
    height: hideElement ? 0 : ""
  };
}

class DraggableTextElement extends React.Component {
  componentDidMount() {
    this.props.connectDragPreview(getEmptyImage(), {
      captureDraggingState: true
    });
  }

  setImageUrl = () => {
    const font = this.props.textElement.font || "fixed",
      size = this.props.textElement.size,
      urlEncodeText = encodeURIComponent(this.props.textElement.text),
      transform_type = this.props.textElement.transform_type,
      transform_amount = this.props.textElement.transform_amount,
      letter_spacing = this.props.textElement.letter_spacing,
      rotation = this.props.textElement.rotation,
      layer = this.props.design.layer_set[this.props.layerId],
      embossed = layer.is_embossed ? 1 : 0,
      repousse = layer.is_repousse ? 1 : 0,
      cutout = layer.is_cutout ? 1 : 0,
      shadowcut = layer.is_shadow_cut ? 1 : 0,
      raised = layer.is_raised ? 1 : 0;

    let color = layer.print_color;
    if (layer.print_color_from_layer !== "") {
      let fromLayer = this.props.design.layer_set[layer.print_color_from_layer];
      if (layer.print_color_type === "Paper") {
        color = fromLayer.color;
      } else {
        color = fromLayer.print_color;
      }
    }

    const color_id = color ? color.id : "24";
    let style = `&embossed=${embossed}&repousse=${repousse}&cutout=${cutout}&shadowcut=${shadowcut}&raised=${raised}`;
    let path = `text?text=${urlEncodeText}&font_id=${font.id}&font_size=${size}&color_id=${color_id}&format=png&letter_spacing=${letter_spacing}&rotation=${rotation}&dimensions=1${style}`;
    let url = process.env.REACT_APP_TEXT_EFFECTS_URL + path;
    url += "&scale=" + this.props.design.preview_scale;
    if (transform_amount && transform_type) {
      url += `&text_effect=${transform_type}&transform_amount=${transform_amount}`;
    }

    return url;
  };

  render() {
    const { connectDragSource } = this.props;
    const imageUrl = this.setImageUrl();

    const element = (
      <div className="draggable-text" style={getStyles(this.props)}>
        <TextElement
          index={this.props.index}
          layerId={this.props.layerId}
          textElement={this.props.textElement}
          itemType={ItemTypes.TEXT}
          design={this.props.design}
          imageUrl={imageUrl}
          disableInteractivity={this.props.disableInteractivity}
          onShow2ndTip={this.props.onShow2ndTip}
          didShow2ndTip={this.props.didShow2ndTip}
          handleHide2ndTip={this.props.handleHide2ndTip}
          textElementsCount={this.props.textElementsCount}
          layer={this.props.layer}
        />
      </div>
    );

    return this.props.disableInteractivity
      ? element
      : connectDragSource(element);
  }
}

DraggableTextElement.propTypes = {
  layerId: PropTypes.number.isRequired,
  textElement: PropTypes.object.isRequired,
  design: PropTypes.object.isRequired
};
export default DragSource(
  ItemTypes.TEXT,
  textSource,
  collect
)(DraggableTextElement);
